import React from 'react';
import BookmarksContain from '../../Componant/BookMarks';

const Bookmark = () => {
  return (
    <div className='page-body'>
      <BookmarksContain />
    </div>
  );
};

export default Bookmark;
